module.exports = {
	"classes": [
		"resources",
		"header-dark"
	],
	"title": "Resources",
	"metas": {
		"description": "Learn how we secure and solve the most complex identity use cases with an extensible, easy to integrate platform that powers trillions of logins every year."
	},
	"opengraph": {
		"og:title": "Resources",
		"og:description": "Learn how we secure and solve the most complex identity use cases with an extensible, easy to integrate platform that powers trillions of logins every year.",
		"og:url": "https://auth0.com/resources",
		"og:image": "https://cdn.auth0.com/website/assets/pages/resources/img/new-twitter-card-35f9a33c39.png",
		"og:image:secure_url": "https://cdn.auth0.com/website/assets/pages/resources/img/new-twitter-card-35f9a33c39.png"
	},
	"twittercard": {
		"twitter:title": "Resources",
		"twitter:description": "Learn how we secure and solve the most complex identity use cases with an extensible, easy to integrate platform that powers trillions of logins every year.",
		"twitter:image": [
			{
				"src": "https://cdn.auth0.com/website/assets/pages/resources/img/new-twitter-card-35f9a33c39.png"
			}
		]
	},
	"canonical": "/resources"
};


//////////////////
// WEBPACK FOOTER
// ./src/pages/resources/metadata.json
// module id = 1141
// module chunks = 0